export const TEST_SITE_NAME = "Horizon";
